export enum ProductTypeEnum {
  Unspecified = 0,
  Course = 1,
  Book = 2,
  Program = 3,
  Journey = 4,
  MasterClass = 5,
  LiveMeeting = 6,
  AnalysisReport = 7,
  PracticeExam = 8,
  Survey = 9,
  Event = 10,
}
